function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import chroma from 'chroma-js';
import iconSpriteSheet from '@govhhs/govhhs-design-system-core/dist/icons/icon-sprite-sheet.svg';
import pictogramSpriteSheet from '@govhhs/govhhs-design-system-core/dist/pictograms/pictogram-sprite-sheet.svg';
import classNames from 'classnames';
export var RadioButtonContext = /*#__PURE__*/React.createContext({
  checked: undefined,
  small: undefined
});
export { default as uniqueIdForComponent } from './uniqueIdForComponent';
export function getOtherProps(propTypes, props) {
  var otherProps = _objectSpread({}, props);
  Object.keys(propTypes).forEach(function (key) {
    delete otherProps[key];
  });
  return otherProps;
}
export var GRID_WIDTHS = ['1/1', '1/2', '1/3', '2/3', '1/4', '3/4', '1/6', '5/6', '1/12', '5/12', '7/12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '12'];
export var GRID_OFFSETS = ['1/12', '1/6', '1/4', '1/3', '1/2', '5/12', '7/12', '2/3', '3/4', '5/6', '11/12'];
export function getAutoGridCSS(autoGridClassname, minWidth, gridGap) {
  var gridGapStyle = gridGap ? "\n    .wds-l-grid--auto.".concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix {\n      margin-left: -").concat(gridGap / 2, "px;\n      margin-right: -").concat(gridGap / 2, "px;\n    }\n\n    .wds-l-grid--auto.").concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix > * {\n      margin-left: ").concat(gridGap / 2, "px;\n      margin-right: ").concat(gridGap / 2, "px;\n      margin-bottom: ").concat(gridGap, "px;\n    }\n\n    @supports (display: grid) {\n      .wds-l-grid--auto.").concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix {\n          ").concat(gridGap ? "grid-gap: ".concat(gridGap, "px;") : '', "\n          margin-bottom: 0;\n      }\n    }\n    ") : '';
  var minWidthStyle = minWidth ? "\n    .wds-l-grid--auto.".concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix > * {\n      flex: 1 1 ").concat(minWidth, "px;\n      margin-bottom: 0;\n    }\n\n    @supports (display: grid) {\n      .wds-l-grid--auto.").concat(autoGridClassname, "[data-eq-state$='aboveMin'] > * {\n        grid-template-columns: repeat(auto-fit, minmax(").concat(minWidth, "px, 1fr ));\n      }\n    }") : '';
  return "".concat(gridGapStyle, "\n  ").concat(minWidthStyle);
}
export var X_SMALL_ICON_LIST = ['caret-down', 'caret-left', 'caret-right', 'caret-up'];
export var ICON_LIST = ['alarm-clock', 'alert', 'archive', 'attachment', 'bell', 'book', 'bookmark', 'bookmark-filled', 'bullhorn', 'calendar', 'camera', 'case', 'chat', 'checkmark', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clock', 'close', 'company', 'danger', 'dash', 'delete', 'document', 'download', 'edit-off', 'ellipsis', 'external-link', 'eye', 'favourite', 'filter', 'folder', 'help', 'home', 'info', 'link', 'location', 'lock', 'mail', 'map', 'maximize', 'menu', 'minimize', 'minus', 'mobile-phone', 'page-first', 'page-last', 'pages', 'partner', 'pencil', 'pencil-page', 'phone', 'plus', 'power', 'print', 'purchase', 'reset', 'search', 'send', 'star', 'stop-sign', 'success', 'tag', 'target', 'translate', 'unlock', 'unsuccess', 'upload', 'user'];
export var PICTOGRAM_LIST = ['application', 'cash-assistance', 'childcare-assistance', 'eligibility', 'employment-benefit', 'long-term-disability', 'low-income-subsidy', 'medicaid', 'national-pension', 'rent-subsidy', 'school-start-subsidy', 'snap', 'student-loan'];
export var ICON_SIZES = ['medium', 'small', 'xsmall'];
export var PICTOGRAM_SIZES = ['medium', 'small'];
export var INPUT_SIZES = ['x-small', 'small', 'medium', 'large', 'x-large'];
export function sizeForIcon(iconSize) {
  switch (iconSize) {
    case 'medium':
      return 24;
    case 'small':
      return 16;
    case 'xsmall':
      return 10;
    default:
      {
        console.error('Invalid size specified for icon. Expected one of ', ICON_SIZES);
        return undefined;
      }
  }
}
export function sizeForPictogram(pictogramSize) {
  switch (pictogramSize) {
    case 'medium':
      return 60;
    case 'small':
      return 36;
    default:
      {
        console.error('Invalid size specified for pictogram. Expected one of ', PICTOGRAM_SIZES);
        return undefined;
      }
  }
}
export var AVATAR_SIZES = ['large', 'medium', 'small'];
export var sizeForAvatar = function sizeForAvatar(size) {
  switch (size) {
    case 'small':
      return 36;
    case 'medium':
      return 60;
    case 'large':
      return 120;
    default:
      {
        console.error('Invalid size specified for avatar. Expected one of ', AVATAR_SIZES);
        return undefined;
      }
  }
};
export function widthClass(width) {
  if (!width) {
    return undefined;
  }
  var widthArrayIndex = 0;
  var foundWidth = false;
  while (widthArrayIndex < GRID_WIDTHS.length && !foundWidth) {
    if (GRID_WIDTHS[widthArrayIndex] === width) {
      foundWidth = true;
    }
    widthArrayIndex += 1;
  }
  if (!foundWidth) {
    console.error('Invalid width specified in grid:', width, '- valid values must be one of ', GRID_WIDTHS);
  }
  return classNames({
    'wds-l-width-one-whole': width === '1/1' || width === '12',
    'wds-l-width-one-half': width === '1/2' || width === '6',
    'wds-l-width-one-third': width === '1/3' || width === '4',
    'wds-l-width-two-thirds': width === '2/3' || width === '8',
    'wds-l-width-one-fourth': width === '1/4' || width === '3',
    'wds-l-width-three-fourths': width === '3/4' || width === '9',
    'wds-l-width-one-sixth': width === '1/6' || width === '2',
    'wds-l-width-five-sixths': width === '5/6' || width === '10',
    'wds-l-width-one-twelfth': width === '1/12' || width === '1',
    'wds-l-width-five-twelfths': width === '5/12' || width === '5',
    'wds-l-width-seven-twelfths': width === '7/12' || width === '7'
  });
}
export function offsetClass(offset) {
  if (!offset) {
    return undefined;
  }
  var offsetArrayIndex = 0;
  var foundOffset = false;
  while (offsetArrayIndex < GRID_OFFSETS.length && !foundOffset) {
    if (GRID_OFFSETS[offsetArrayIndex] === offset) {
      foundOffset = true;
    }
    offsetArrayIndex += 1;
  }
  if (!foundOffset) {
    console.error('Invalid offset specified in grid: ', offset, '- valid values must be one of ', GRID_OFFSETS);
  }
  return classNames({
    'wds-l-offset-one-twelfth': offset === '1/12',
    'wds-l-offset-one-sixth': offset === '1/6',
    'wds-l-offset-one-fourth': offset === '1/4',
    'wds-l-offset-one-third': offset === '1/3',
    'wds-l-offset-five-twelfths': offset === '5/12',
    'wds-l-offset-one-half': offset === '1/2',
    'wds-l-offset-seven-twelfths': offset === '7/12',
    'wds-l-offset-two-thirds': offset === '2/3',
    'wds-l-offset-three-fourths': offset === '3/4',
    'wds-l-offset-five-sixths': offset === '5/6',
    'wds-l-offset-eleven-twelfths': offset === '11/12'
  });
}
export var setFocusWith0Delay = function setFocusWith0Delay(element) {
  element.focus(); // instant focus and lazy focus required for IE11
  setTimeout(function (_element) {
    _element.focus();
  }, 0, element);
};
export var flatten = function flatten(list) {
  return list.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};
export var ConditionalContainer = function ConditionalContainer(_ref) {
  var condition = _ref.condition,
    container = _ref.container,
    children = _ref.children;
  return condition ? container(children) : children;
};
export { iconSpriteSheet, pictogramSpriteSheet };
export var themeLuminanceValues = [95.5, 90.3, 74.8, 56.4, 38.9, 26.7, 15.9, 8.4, 4.1, 1.9, 0.8, 0.4];
export var themeColorStopNumbers = [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 105];
export var COLORS = {
  RGB: {
    BLACK: {
      r: 0,
      g: 0,
      b: 0
    },
    WHITE: {
      r: 255,
      g: 255,
      b: 255
    }
  },
  HEX: {
    BLACK: '#000000',
    WHITE: '#FFFFFF'
  }
};
export var themeTemplates = [{
  name: 'Default',
  value: '0',
  themeProvidersConfig: {
    root: 'default',
    header: undefined,
    hero: undefined,
    footer: undefined
  }
}, {
  name: 'Dark',
  value: '1',
  themeProvidersConfig: {
    root: 'dark',
    header: undefined,
    hero: undefined,
    footer: undefined
  }
}, {
  name: 'Default with Dark header',
  value: '2',
  themeProvidersConfig: {
    root: 'default',
    header: 'dark',
    hero: undefined,
    footer: undefined
  }
}, {
  name: 'Branded light',
  value: '3',
  themeProvidersConfig: {
    root: 'brandedLight',
    header: undefined,
    hero: undefined,
    footer: undefined
  }
}, {
  name: 'Branded dark',
  value: '4',
  themeProvidersConfig: {
    root: 'brandedDark',
    header: undefined,
    hero: undefined,
    footer: undefined
  }
}];
export var mapRange = function mapRange(number, inMin, inMax, outMin, outMax) {
  return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
};
export var generateTonalColorPalletWithChroma = function generateTonalColorPalletWithChroma(colorAsHex) {
  if (chroma.valid(colorAsHex)) {
    var palette = {};
    themeColorStopNumbers.forEach(function (colorStop, index) {
      palette[colorStop] = chroma(colorAsHex).luminance(mapRange(themeLuminanceValues[index], 0, 100, 0, 1)).hex();
    });
    return palette;
  }
  return false;
};
export var getThemeProvidersConfigurationByValue = function getThemeProvidersConfigurationByValue(value) {
  return themeTemplates.filter(function (themeTemplate) {
    return themeTemplate.value === value;
  })[0].themeProvidersConfig;
};
var wdsColorPalette = {
  black: {
    100: '#100'
  },
  blue: {
    5: '#f8fafe',
    10: '#f0f5fc',
    20: '#d2e1f7',
    30: '#abc8f0',
    40: '#7eaae8',
    50: '#538ee1',
    60: '#256dd2',
    70: '#1c519c',
    80: '#13386c',
    90: '#0d2547',
    100: '#08162b',
    105: '#040d19'
  },
  'cool-gray': {
    10: '#f2f4f8',
    20: '#dde1e6',
    30: '#c1c7cd',
    40: '#a2a9b0',
    50: '#878d96',
    60: '#697077',
    70: '#4d5358',
    80: '#343a3f',
    90: '#21272a',
    100: '#121619'
  },
  cyan: {
    5: '#f0fcfd',
    10: '#dff9fc',
    20: '#a1edf6',
    30: '#37d9eb',
    40: '#14b9cb',
    50: '#119baa',
    60: '#0e7b87',
    70: '#0a5b64',
    80: '#074046',
    90: '#052a2e',
    100: '#03191c',
    105: '#020f11'
  },
  gray: {
    15: '#fafafa',
    10: '#f3f4f4',
    20: '#dee1e1',
    30: '#c2c7c7',
    40: '#a3aaaa',
    50: '#858f8f',
    60: '#687171',
    70: '#4d5454',
    80: '#353a3a',
    90: '#232626',
    100: '#141616',
    105: '#0c0d0d'
  },
  green: {
    5: '#f6fcf8',
    10: '#eaf8ee',
    20: '#c2eacd',
    30: '#8ad7a0',
    40: '#43bf66',
    50: '#37a054',
    60: '#2b7f43',
    70: '#205e32',
    80: '#164122',
    90: '#0f2b17',
    100: '#09190d',
    105: '#050f08'
  },
  magenta: {
    10: '#fff0f7',
    20: '#ffd6e8',
    30: '#ffafd2',
    40: '#ff7eb6',
    50: '#ee5396',
    60: '#d02670',
    70: '#9f1853',
    80: '#740937',
    90: '#510224',
    100: '#2a0a18'
  },
  orange: {
    5: '#fff9f5',
    10: '#fff2e9',
    20: '#ffd9be',
    30: '#ffb682',
    40: '#ff8833',
    50: '#ec6200',
    60: '#bb4e00',
    70: '#8b3a00',
    80: '#612800',
    90: '#411b00',
    100: '#271000',
    105: '#170a00'
  },
  purple: {
    5: '#fdf9fd',
    10: '#faf1fb',
    20: '#f1d9f4',
    30: '#e5b7eb',
    40: '#d68fdf',
    50: '#c767d4',
    60: '#b137c1',
    70: '#842990',
    80: '#5c1d65',
    90: '#3e1343',
    100: '#250b28',
    105: '#170719'
  },
  red: {
    5: '#fef9f9',
    10: '#fdf1f1',
    20: '#fbd8d9',
    30: '#f7b6b7',
    40: '#f28b8d',
    50: '#ed5d60',
    60: '#dc191c',
    70: '#a51315',
    80: '#750d0f',
    90: '#4f090a',
    100: '#310606',
    105: '#200404'
  },
  teal: {
    10: '#dff9fc',
    20: '#a0edf5',
    30: '#37d9eb',
    40: '#14b9cb',
    50: '#119baa',
    60: '#0e7b87',
    70: '#0a5b64',
    80: '#074046',
    90: '#052a2e',
    100: '#03191c'
  },
  'warm-gray': {
    10: '#f7f3f2',
    20: '#e5e0df',
    30: '#cac5c4',
    40: '#ada8a8',
    50: '#8f8b8b',
    60: '#726e6e',
    70: '#565151',
    80: '#3c3838',
    90: '#272525',
    100: '#171414'
  },
  white: {
    0: '#ffffff'
  },
  yellow: {
    5: '#fffae1',
    10: '#fff5c3',
    20: '#ffe045',
    30: '#eac300',
    40: '#c7a600',
    50: '#a78b00',
    60: '#846e00',
    70: '#615100',
    80: '#443900',
    90: '#2d2500',
    100: '#1a1600',
    105: '#100d00'
  }
};
var wdsColorPaletteForHover = {
  blue: {
    5: '#eef4fc',
    10: '#e0ebfa',
    20: '#bdd4f3',
    30: '#91b7eb',
    40: '#6499e3',
    50: '#367bdb',
    60: '#205cb1',
    70: '#2262bc',
    80: '#19488a',
    90: '#113260',
    100: '#0e284d',
    105: '#091a32'
  },
  cyan: {
    5: '#dff9fc',
    10: '#bff3f9',
    20: '#6be3f0',
    30: '#16c6da',
    40: '#12a7b7',
    50: '#0f8996',
    60: '#0b6872',
    70: '#0c6f7a',
    80: '#095159',
    90: '#06383d',
    100: '#052d31',
    105: '#031d20'
  },
  gray: {
    5: '#f3f4f4',
    10: '#e8eaea',
    20: '#ced2d2',
    30: '#afb5b5',
    40: '#919999',
    50: '#747e7e',
    60: '#585f5f',
    70: '#5e6666',
    80: '#444a4a',
    90: '#2f3333',
    100: '#252828',
    105: '#181a1a'
  },
  red: {
    5: '#fdf1f1',
    10: '#fce4e4',
    20: '#f8c5c6',
    30: '#f49d9e',
    40: '#ef7072',
    50: '#e83639',
    60: '#ba1518',
    70: '#c7171a',
    80: '#931113',
    90: '#680c0d',
    100: '#540a0b',
    105: '#380607'
  },
  white: {
    0: '#e3e5e5'
  }
};

// * generate token map with primary and secondary, fallback to default colors
// for a given theme type [default(light), dark, branded light, branded dark]
// what value should I set for each of the design tokens given
// a list of primary shades
// a list of secondary shades

// These are the base values used to generate new custom property tokens for the themebuilder
export var generateTokensForTypes = function generateTokensForTypes(primaryColorPalette, secondaryColorPalette) {
  var tokenMap = [{
    prefix: 'cds-',
    name: 'background',
    value: {
      default: wdsColorPalette.gray[10],
      dark: wdsColorPalette.gray[90],
      brandedLight: secondaryColorPalette[5] || wdsColorPalette.cyan[5],
      brandedDark: secondaryColorPalette[105] || wdsColorPalette.cyan[105]
    }
  }, {
    prefix: 'cds-',
    name: 'background-active',
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[50], ", .5)"),
      dark: "rgba(".concat(wdsColorPalette.gray[50], ", .4)"),
      brandedLight: "rgba(".concat(secondaryColorPalette[50], ", .5)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .5)"),
      brandedDark: "rgba(".concat(secondaryColorPalette[50], ", .5)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .5)")
    }
  }, {
    prefix: 'cds-',
    name: 'background-brand',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[50] || wdsColorPalette.blue[60],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'background-hover',
    value: {
      default: 'hsla(180,4%,54%,.12)',
      // `rgba(${wdsColorPalette.gray[50]}, .12)`,
      dark: 'hsla(180,4%,54%,.32)',
      // TODO fix
      brandedLight: "rgba(".concat(secondaryColorPalette[50], ", .12)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .12)"),
      brandedDark: "rgba(".concat(secondaryColorPalette[50], ", .12)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .12)")
    }
  }, {
    prefix: 'cds-',
    name: 'background-inverse',
    value: {
      default: wdsColorPalette.gray[80],
      dark: wdsColorPalette.gray[10],
      brandedLight: '',
      brandedDark: ''
    }
  }, {
    prefix: 'cds-',
    name: 'background-inverse-hover',
    value: {
      default: wdsColorPaletteForHover.gray[80],
      dark: wdsColorPaletteForHover.gray[10],
      brandedLight: wdsColorPalette.gray[80],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'background-selected',
    // rgba(color-pallet.get('gray', 50), .24)
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[50], ", .12)"),
      dark: "rgba(".concat(wdsColorPalette.gray[50], ", .12)"),
      brandedLight: "rgba(".concat(secondaryColorPalette[50], ", .2)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .2)"),
      brandedDark: "rgba(".concat(secondaryColorPalette[50], ", .2)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .2)")
    }
  }, {
    prefix: 'cds-',
    name: 'background-selected-hover',
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[50], ", .32)"),
      dark: "rgba(".concat(wdsColorPalette.gray[50], ", .32)"),
      brandedLight: "rgba(".concat(secondaryColorPalette[50], ", .32)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .32)"),
      brandedDark: "rgba(".concat(secondaryColorPalette[50], ", .32)") || "rgba(".concat(wdsColorPalette.cyan[50], ", .32)")
    }
  }, {
    prefix: 'cds-',
    name: 'border-disabled',
    value: {
      default: wdsColorPalette.gray[30],
      dark: "rgba(".concat(wdsColorPalette.gray[50], ", .5)"),
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: "rgba(".concat(wdsColorPalette.gray[50], ", .5)")
    }
  }, {
    prefix: 'cds-',
    name: 'border-interactive',
    value: {
      default: primaryColorPalette[50] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[40] || wdsColorPalette.blue[50],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[50] || wdsColorPalette.blue[50]
    }
  }, {
    prefix: 'cds-',
    name: 'border-inverse',
    value: {
      default: wdsColorPalette.gray[100],
      dark: wdsColorPalette.gray[10],
      brandedLight: wdsColorPalette.gray[100],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'border-strong-01',
    value: {
      default: wdsColorPalette.gray[50],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'border-strong-02',
    value: {
      default: wdsColorPalette.gray[50],
      dark: wdsColorPalette.gray[40],
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[40]
    }
  }, {
    prefix: 'cds-',
    name: 'border-strong-03',
    value: {
      default: wdsColorPalette.gray[50],
      dark: wdsColorPalette.gray[30],
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[30]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-00',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-01',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-02',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-03',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-selected-01',
    value: {
      default: wdsColorPalette.gray[30],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-selected-02',
    value: {
      default: wdsColorPalette.gray[30],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'border-subtle-selected-03',
    value: {
      default: wdsColorPalette.gray[30],
      dark: wdsColorPalette.gray[40],
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: wdsColorPalette.gray[40]
    }
  }, {
    prefix: 'cds-',
    name: 'field-01',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[80],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'field-02',
    value: {
      default: wdsColorPalette.gray[10],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[10],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'field-03',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'field-hover-01',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[80],
      brandedLight: wdsColorPaletteForHover.white[0],
      brandedDark: wdsColorPaletteForHover.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'field-hover-02',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[70],
      brandedLight: wdsColorPaletteForHover.gray[10],
      brandedDark: wdsColorPaletteForHover.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'field-hover-03',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[60],
      brandedLight: wdsColorPaletteForHover.white[0],
      brandedDark: wdsColorPaletteForHover.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'focus',
    value: {
      default: wdsColorPalette.blue[60],
      dark: wdsColorPalette.white[0],
      brandedLight: wdsColorPalette.blue[60],
      // TODO ?? check
      brandedDark: wdsColorPalette.white[0]
    }
  }, {
    prefix: 'cds-',
    name: 'focus-inset',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[100],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[100]
    }
  }, {
    prefix: 'cds-',
    name: 'focus-inverse',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.blue[60],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'highlight',
    value: {
      default: secondaryColorPalette[40] || wdsColorPalette.cyan[20],
      dark: secondaryColorPalette[60] || wdsColorPalette.cyan[80],
      brandedLight: secondaryColorPalette[50] || wdsColorPalette.cyan[50],
      brandedDark: secondaryColorPalette[60] || wdsColorPalette.cyan[60]
    }
  }, {
    prefix: 'cds-',
    name: 'icon-disabled',
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[100], ", .25)"),
      dark: "rgba(".concat(wdsColorPalette.gray[10], ", .25)"),
      brandedLight: "rgba(".concat(wdsColorPalette.gray[100], ", .25)"),
      brandedDark: "rgba(".concat(wdsColorPalette.gray[10], ", .25)")
    }
  }, {
    prefix: 'cds-',
    name: 'icon-inverse',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[100],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[100]
    }
  }, {
    prefix: 'cds-',
    name: 'icon-on-color',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.white[0],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.white[0]
    }
  }, {
    prefix: 'cds-',
    name: 'icon-on-color-disabled',
    value: {
      default: wdsColorPalette.gray[50],
      dark: "rgba(".concat(wdsColorPalette.white[0], ", .25)"),
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'icon-primary',
    value: {
      default: wdsColorPalette.gray[100],
      dark: wdsColorPalette.gray[10],
      brandedLight: wdsColorPalette.gray[100],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'icon-secondary',
    value: {
      default: wdsColorPalette.gray[70],
      dark: wdsColorPalette.gray[30],
      brandedLight: wdsColorPalette.gray[70],
      brandedDark: wdsColorPalette.gray[30]
    }
  }, {
    prefix: 'cds-',
    name: 'interactive',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[50] || wdsColorPalette.blue[50],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[50] || wdsColorPalette.blue[50]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-01',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[80],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-02',
    value: {
      default: wdsColorPalette.gray[10],
      dark: wdsColorPalette.gray[70],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[70] || wdsColorPalette.blue[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-03',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-01',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-02',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[60],
      brandedLight: primaryColorPalette[20] || wdsColorPalette.blue[20],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-03',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-active-01',
    value: {
      default: wdsColorPalette.gray[40],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.gray[40],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-active-02',
    value: {
      default: wdsColorPalette.gray[40],
      dark: wdsColorPalette.gray[80],
      brandedLight: primaryColorPalette[40] || wdsColorPalette.blue[40],
      brandedDark: primaryColorPalette[80] || wdsColorPalette.blue[80]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-active-03',
    value: {
      default: wdsColorPalette.gray[40],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[40],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-hover-01',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[70],
      brandedLight: wdsColorPaletteForHover.gray[20],
      brandedDark: wdsColorPaletteForHover.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-hover-02',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[60],
      brandedLight: primaryColorPalette[30] || wdsColorPaletteForHover.blue[20],
      brandedDark: primaryColorPalette[50] || wdsColorPaletteForHover.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-accent-hover-03',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[50],
      brandedLight: wdsColorPaletteForHover.gray[20],
      brandedDark: wdsColorPaletteForHover.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-active-01',
    value: {
      default: wdsColorPalette.gray[30],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-active-02',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[50],
      brandedLight: primaryColorPalette[30] || wdsColorPalette.blue[30],
      brandedDark: primaryColorPalette[50] || wdsColorPalette.blue[50]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-active-03',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[80],
      brandedLight: wdsColorPalette.gray[30],
      brandedDark: wdsColorPalette.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-hover-01',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[80],
      brandedLight: wdsColorPaletteForHover.white[0],
      brandedDark: wdsColorPaletteForHover.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-hover-02',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[70],
      brandedLight: primaryColorPalette[20] || wdsColorPaletteForHover.blue[10],
      brandedDark: primaryColorPalette[60] || wdsColorPaletteForHover.blue[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-hover-03',
    value: {
      default: wdsColorPaletteForHover.gray[10],
      dark: wdsColorPaletteForHover.gray[60],
      brandedLight: wdsColorPaletteForHover.white[0],
      brandedDark: wdsColorPaletteForHover.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-01',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-02',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[60],
      brandedLight: primaryColorPalette[20] || wdsColorPalette.blue[20],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-03',
    value: {
      default: wdsColorPalette.gray[20],
      dark: wdsColorPalette.gray[70],
      brandedLight: wdsColorPalette.gray[20],
      brandedDark: wdsColorPalette.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-disabled',
    value: {
      default: wdsColorPalette.gray[50],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-hover-01',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[70],
      brandedLight: wdsColorPaletteForHover.gray[20],
      brandedDark: wdsColorPaletteForHover.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-hover-02',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[60],
      brandedLight: primaryColorPalette[30] || wdsColorPaletteForHover.blue[20],
      brandedDark: primaryColorPalette[40] || wdsColorPaletteForHover.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-hover-03',
    value: {
      default: wdsColorPaletteForHover.gray[20],
      dark: wdsColorPaletteForHover.gray[70],
      brandedLight: wdsColorPaletteForHover.gray[20],
      brandedDark: wdsColorPaletteForHover.gray[70]
    }
  }, {
    prefix: 'cds-',
    name: 'layer-selected-inverse',
    value: {
      default: wdsColorPalette.gray[100],
      dark: wdsColorPalette.gray[10],
      brandedLight: wdsColorPalette.gray[100],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'link-inverse',
    value: {
      default: wdsColorPalette.blue[40],
      dark: wdsColorPalette.blue[60],
      brandedLight: wdsColorPalette.blue[40],
      brandedDark: wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'link-inverse-active',
    value: {
      default: wdsColorPalette.gray[10],
      dark: wdsColorPalette.gray[100],
      brandedLight: wdsColorPalette.gray[10],
      brandedDark: wdsColorPalette.gray[100]
    }
  }, {
    prefix: 'cds-',
    name: 'link-inverse-hover',
    value: {
      default: wdsColorPalette.blue[30],
      dark: wdsColorPalette.blue[70],
      brandedLight: wdsColorPalette.blue[30],
      brandedDark: wdsColorPalette.blue[70]
    }
  }, {
    prefix: 'cds-',
    name: 'link-primary',
    value: {
      default: wdsColorPalette.blue[60],
      dark: wdsColorPalette.blue[40],
      brandedLight: wdsColorPalette.blue[60],
      brandedDark: wdsColorPalette.blue[40]
    }
  }, {
    prefix: 'cds-',
    name: 'link-primary-hover',
    value: {
      default: wdsColorPalette.blue[70],
      dark: wdsColorPalette.blue[30],
      brandedLight: wdsColorPalette.blue[70],
      brandedDark: wdsColorPalette.blue[30]
    }
  }, {
    prefix: 'cds-',
    name: 'link-secondary',
    value: {
      default: wdsColorPalette.blue[70],
      dark: wdsColorPalette.blue[30],
      brandedLight: wdsColorPalette.blue[70],
      brandedDark: wdsColorPalette.blue[30]
    }
  }, {
    prefix: 'cds-',
    name: 'link-visited',
    value: {
      default: wdsColorPalette.purple[70],
      dark: wdsColorPalette.purple[40],
      brandedLight: wdsColorPalette.purple[60],
      brandedDark: wdsColorPalette.purple[40]
    }
  }, {
    prefix: 'cds-',
    name: 'overlay',
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[100], ", .5)"),
      dark: "rgba(".concat(wdsColorPalette.gray[100], ", .7)"),
      brandedLight: "rgba(".concat(wdsColorPalette.gray[100], ", .5)"),
      brandedDark: "rgba(".concat(wdsColorPalette.gray[100], ", .7)")
    }
  }, {
    prefix: 'cds-',
    name: 'shadow',
    value: {
      default: 'rgba(0, 0, 0, .3)',
      dark: 'rgba(0, 0, 0, .8)',
      brandedLight: 'rgba(0, 0, 0, .3)',
      brandedDark: 'rgba(0, 0, 0, .8)'
    }
  }, {
    prefix: 'cds-',
    name: 'text-disabled',
    value: {
      default: "rgba(".concat(wdsColorPalette.gray[100], ", .25)"),
      dark: "rgba(".concat(wdsColorPalette.gray[10], ", .1)"),
      brandedLight: "rgba(".concat(wdsColorPalette.gray[100], ", .25)"),
      brandedDark: "rgba(".concat(wdsColorPalette.gray[10], ", .25)")
    }
  }, {
    prefix: 'cds-',
    name: 'text-error',
    value: {
      default: wdsColorPalette.red[60],
      dark: wdsColorPalette.red[30],
      brandedLight: wdsColorPalette.red[60],
      brandedDark: wdsColorPalette.red[30]
    }
  }, {
    prefix: 'cds-',
    name: 'text-inverse',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[100],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[100]
    }
  }, {
    prefix: 'cds-',
    name: 'text-on-color',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.white[0],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.white[0]
    }
  }, {
    prefix: 'cds-',
    name: 'text-placeholder',
    value: {
      default: wdsColorPalette.gray[40],
      dark: wdsColorPalette.gray[60],
      brandedLight: wdsColorPalette.gray[40],
      brandedDark: wdsColorPalette.gray[60]
    }
  }, {
    prefix: 'cds-',
    name: 'text-primary',
    value: {
      default: wdsColorPalette.gray[100],
      dark: wdsColorPalette.gray[10],
      brandedLight: wdsColorPalette.gray[100],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'text-secondary',
    value: {
      default: wdsColorPalette.gray[70],
      dark: wdsColorPalette.gray[30],
      brandedLight: wdsColorPalette.gray[70],
      brandedDark: wdsColorPalette.gray[30]
    }
  }, {
    prefix: 'cds-',
    name: 'toggle-off',
    value: {
      default: wdsColorPalette.gray[50],
      dark: wdsColorPalette.gray[50],
      brandedLight: wdsColorPalette.gray[50],
      brandedDark: wdsColorPalette.gray[50]
    }
  }, {
    prefix: 'cds-',
    name: 'field',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.gray[80],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.gray[80]
    }
  }, {
    prefix: 'cds-',
    name: 'button-primary',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'button-primary-hover',
    value: {
      default: primaryColorPalette[70] || wdsColorPalette.blue[70],
      dark: primaryColorPalette[70] || wdsColorPalette.blue[70],
      brandedLight: primaryColorPalette[70] || wdsColorPaletteForHover.blue[60],
      brandedDark: primaryColorPalette[50] || wdsColorPaletteForHover.blue[60]
    }
  }, {
    prefix: 'cds-',
    name: 'button-primary-active',
    value: {
      default: primaryColorPalette[80] || wdsColorPalette.blue[80],
      dark: primaryColorPalette[80] || wdsColorPalette.blue[80],
      brandedLight: primaryColorPalette[80] || wdsColorPalette.blue[80],
      brandedDark: primaryColorPalette[80] || wdsColorPalette.blue[80]
    }
  }, {
    prefix: 'cds-',
    name: 'button-tertiary',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[40] || wdsColorPalette.blue[40],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: wdsColorPalette.white[0]
    }
  }, {
    prefix: 'cds-',
    name: 'button-tertiary-hover',
    value: {
      default: primaryColorPalette[70] || wdsColorPalette.blue[70],
      dark: primaryColorPalette[70] || wdsColorPalette.blue[70],
      brandedLight: primaryColorPalette[70] || wdsColorPaletteForHover.blue[60],
      brandedDark: wdsColorPalette.gray[10]
    }
  }, {
    prefix: 'cds-',
    name: 'button-tertiary-active',
    value: {
      default: primaryColorPalette[80] || wdsColorPalette.blue[80],
      dark: primaryColorPalette[80] || wdsColorPalette.blue[80],
      brandedLight: primaryColorPalette[80] || wdsColorPalette.blue[80],
      brandedDark: wdsColorPalette.gray[30]
    }
  }, {
    prefix: 'wds-',
    name: 'button-primary-background',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[60] || wdsColorPalette.blue[60]
    }
  }, {
    prefix: 'wds-',
    name: 'button-primary-background-hover',
    value: {
      default: primaryColorPalette[70] || wdsColorPalette.blue[70],
      dark: primaryColorPalette[70] || wdsColorPalette.blue[70],
      brandedLight: primaryColorPalette[70] || wdsColorPalette.blue[70],
      brandedDark: primaryColorPalette[70] || wdsColorPalette.blue[70]
    }
  }, {
    prefix: 'wds-',
    name: 'button-primary-text',
    value: {
      default: wdsColorPalette.white[0],
      dark: wdsColorPalette.white[0],
      brandedLight: wdsColorPalette.white[0],
      brandedDark: wdsColorPalette.white[0]
    }
  }, {
    prefix: 'wds-',
    name: 'button-border-radius',
    value: {
      default: '100vw',
      dark: '100vw',
      brandedLight: '100vw',
      brandedDark: '100vw'
    }
  }, {
    prefix: 'wds-',
    name: 'checkbox-color',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[50] || wdsColorPalette.blue[50],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[50] || wdsColorPalette.blue[50]
    }
  }, {
    prefix: 'wds-',
    name: 'radio-button-color',
    value: {
      default: primaryColorPalette[60] || wdsColorPalette.blue[60],
      dark: primaryColorPalette[50] || wdsColorPalette.blue[50],
      brandedLight: primaryColorPalette[60] || wdsColorPalette.blue[60],
      brandedDark: primaryColorPalette[50] || wdsColorPalette.blue[50]
    }
  }, {
    prefix: 'wds-',
    name: 'text-on-secondary',
    value: {
      default: secondaryColorPalette[80] || wdsColorPalette.cyan[80],
      dark: secondaryColorPalette[40] || wdsColorPalette.cyan[40],
      brandedLight: secondaryColorPalette[80] || wdsColorPalette.cyan[80],
      brandedDark: secondaryColorPalette[40] || wdsColorPalette.cyan[40]
    }
  }, {
    prefix: 'wds-',
    name: 'background-secondary',
    value: {
      default: secondaryColorPalette[40] || wdsColorPalette.cyan[40],
      dark: secondaryColorPalette[80] || wdsColorPalette.cyan[80],
      brandedLight: secondaryColorPalette[40] || wdsColorPalette.cyan[40],
      brandedDark: secondaryColorPalette[80] || wdsColorPalette.cyan[80]
    }
  }, {
    prefix: 'wds-',
    name: 'img-url-caret-up-down-16',
    value: {
      default: "url('#{variables.$image-path}/caret-up-down-16.svg')",
      dark: "url('#{variables.$image-path}/caret-up-down-16-dark.svg')",
      brandedLight: "url('#{variables.$image-path}/caret-up-down-16.svg')",
      brandedDark: "url('#{variables.$image-path}/caret-up-down-16-dark.svg')"
    }
  }, {
    prefix: 'wds-',
    name: 'img-url-chevron-left-16',
    value: {
      default: "url('#{variables.$image-path}/chevron-left-16.svg')",
      dark: "url('#{variables.$image-path}/chevron-left-16-dark.svg')",
      brandedLight: "url('#{variables.$image-path}/chevron-left-16.svg')",
      brandedDark: "url('#{variables.$image-path}/chevron-left-16-dark.svg')"
    }
  }, {
    prefix: 'wds-',
    name: 'img-url-chevron-right-16',
    value: {
      default: "url('#{variables.$image-path}/chevron-right-16.svg')",
      dark: "url('#{variables.$image-path}/chevron-right-16-dark.svg')",
      brandedLight: "url('#{variables.$image-path}/chevron-right-16.svg')",
      brandedDark: "url('#{variables.$image-path}/chevron-right-16-dark.svg')"
    }
  }];
  return tokenMap;
};
export var replaceTokenImageImportPathForDemo = function replaceTokenImageImportPathForDemo(tokens) {
  if (tokens['--wds-img-url-caret-up-down-16']) {
    // eslint-disable-next-line no-param-reassign
    tokens['--wds-img-url-caret-up-down-16'] = tokens['--wds-img-url-caret-up-down-16'].replace('#{$image-path}', 'static/media/../core/dist/img');
  }
  if (tokens['--wds-img-url-chevron-left-16']) {
    // eslint-disable-next-line no-param-reassign
    tokens['--wds-img-url-chevron-left-16'] = tokens['--wds-img-url-chevron-left-16'].replace('#{$image-path}', 'static/media/../core/dist/img');
  }
  if (tokens['--wds-img-url-chevron-right-16']) {
    // eslint-disable-next-line no-param-reassign
    tokens['--wds-img-url-chevron-right-16'] = tokens['--wds-img-url-chevron-right-16'].replace('#{$image-path}', 'static/media/../core/dist/img');
  }
  return tokens;
};
export var generateThemingConfigurationCodeSnippet = function generateThemingConfigurationCodeSnippet(paletteForPrimaryColor, paletteForSecondaryColor, selectedThemeTemplate, themeTokens) {
  var codeSnippet = '';
  var codeSnippetHeader = "// /src/sass/styles.scss\n@use '@govhhs/govhhs-design-system-core/src/stylesheets/govhhs-wds' as * with (\n  $css--theming-enabled: true,\n); \n";
  var selectedThemeConfiguration = getThemeProvidersConfigurationByValue(selectedThemeTemplate);
  var generatedThemes = [];
  var themesToGenerate = Object.fromEntries(Object.entries(selectedThemeConfiguration).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      _ = _ref3[0],
      themeType = _ref3[1];
    return themeType !== undefined;
  }));
  // for each of the themes, using the them type, generate a token list
  Object.entries(themesToGenerate).forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      location = _ref5[0],
      themeType = _ref5[1];
    if (!generatedThemes.includes(location)) {
      codeSnippet += "\n".concat(location === 'root' ? ':root,' : '', "\n[data-wds-theme='").concat(themeType, "'] {\n").concat(themeTokens.map(function (token) {
        return "  --".concat(token.prefix).concat(token.name, ": ").concat(token.value[themeType], ";");
      }).join('\n'), "\n}");
      generatedThemes.push(location); // record theme generation, preventing it being generated again
    }
  });

  return "".concat(codeSnippetHeader).concat(codeSnippet);
};
export var themeTokensForThemeTypeToInlineStyle = function themeTokensForThemeTypeToInlineStyle(tokens, type) {
  var inlineStyleTokens = {};
  tokens.forEach(function (token) {
    inlineStyleTokens["--".concat(token.prefix).concat(token.name)] = token.value[type];
  });
  return inlineStyleTokens;
};
var findBiggestColorRange = function findBiggestColorRange(rgbValues) {
  var rMin = Number.MAX_VALUE;
  var gMin = Number.MAX_VALUE;
  var bMin = Number.MAX_VALUE;
  var rMax = Number.MIN_VALUE;
  var gMax = Number.MIN_VALUE;
  var bMax = Number.MIN_VALUE;
  rgbValues.forEach(function (pixel) {
    rMin = Math.min(rMin, pixel.r);
    gMin = Math.min(gMin, pixel.g);
    bMin = Math.min(bMin, pixel.b);
    rMax = Math.max(rMax, pixel.r);
    gMax = Math.max(gMax, pixel.g);
    bMax = Math.max(bMax, pixel.b);
  });
  var rRange = rMax - rMin;
  var gRange = gMax - gMin;
  var bRange = bMax - bMin;
  var biggestRange = Math.max(rRange, gRange, bRange);
  if (biggestRange === rRange) {
    return 'r';
  }
  if (biggestRange === gRange) {
    return 'g';
  }
  return 'b';
};
export var buildRgb = function buildRgb(imageData) {
  var rgbValues = [];
  for (var i = 0; i < imageData.length; i += 4) {
    var rgb = {
      r: imageData[i],
      g: imageData[i + 1],
      b: imageData[i + 2]
    };
    rgbValues.push(rgb);
  }
  return rgbValues;
};
export var quantization = function quantization(rgbValues, depth) {
  var MAX_DEPTH = 4;

  // Base case
  if (depth === MAX_DEPTH || rgbValues.length === 0) {
    var color = rgbValues.reduce(function (prev, curr) {
      // eslint-disable-next-line no-param-reassign
      prev.r += curr.r;
      // eslint-disable-next-line no-param-reassign
      prev.g += curr.g;
      // eslint-disable-next-line no-param-reassign
      prev.b += curr.b;
      return prev;
    }, {
      r: 0,
      g: 0,
      b: 0
    });
    color.r = Math.round(color.r / rgbValues.length);
    color.g = Math.round(color.g / rgbValues.length);
    color.b = Math.round(color.b / rgbValues.length);
    return [color];
  }

  /**
   *  Recursively do the following:
   *  1. Find the pixel channel (red,green or blue) with biggest difference/range
   *  2. Order by this channel
   *  3. Divide in half the rgb colors list
   *  4. Repeat process again, until desired depth or base case
   */
  var componentToSortBy = findBiggestColorRange(rgbValues);
  rgbValues.sort(function (p1, p2) {
    return p1[componentToSortBy] - p2[componentToSortBy];
  });
  var mid = rgbValues.length / 2;
  return [].concat(_toConsumableArray(quantization(rgbValues.slice(0, mid), depth + 1)), _toConsumableArray(quantization(rgbValues.slice(mid + 1), depth + 1)));
};
export var isRGBEqual = function isRGBEqual(color1, color2) {
  if (color1.r === color2.r && color1.g === color2.g && color1.b === color2.b) {
    return true;
  }
  return false;
};
export function rgbToHex(color) {
  var r = color.r.toString(16);
  var g = color.g.toString(16);
  var b = color.b.toString(16);
  if (r.length === 1) r = "0".concat(r);
  if (g.length === 1) g = "0".concat(g);
  if (b.length === 1) b = "0".concat(b);
  return "".concat(r).concat(g).concat(b);
}